"use client";

import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface EmailPhoneFieldsProps {
  email: string;
  phone: string;
  errors: { email: string; phone: string };
  warningMessage?: string;
  disabled?: boolean;
  onEmailChange: (v: string) => void;
  onPhoneChange: (v: string) => void;
  emailRef: React.RefObject<HTMLInputElement>;
  phoneRef: React.RefObject<HTMLInputElement>;
}

const EmailPhoneFields: React.FC<EmailPhoneFieldsProps> = ({
  email,
  phone,
  errors,
  warningMessage,
  disabled = false,
  onEmailChange,
  onPhoneChange,
  emailRef,
  phoneRef,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 gap-4">
      <div className="space-y-2 field-row">
        <Label htmlFor="email">{t("contactDetails.emailAddress")}</Label>
        <Input
          id="email"
          name="email"
          autoComplete="email"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          className={cn(errors.email && "border-destructive focus-visible:ring-destructive")}
          disabled={disabled}
          ref={emailRef}
        />
        {errors.email && <p className="text-sm text-destructive">{errors.email}</p>}
        {warningMessage && <p className="text-sm text-amber-500">{warningMessage}</p>}
      </div>
      <div className="space-y-2 field-row">
        <Label htmlFor="phone">{t("contactDetails.phoneNumber")}</Label>
        <Input
          id="phone"
          name="phone"
          autoComplete="tel"
          type="tel"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          className={cn(errors.phone && "border-destructive focus-visible:ring-destructive")}
          disabled={disabled}
          ref={phoneRef}
        />
        {errors.phone && <p className="text-sm text-destructive">{errors.phone}</p>}
      </div>
    </div>
  );
};

export default EmailPhoneFields;
